/**
 * KonfidenzBadge + KonfidenzBar — ported from v0 konfidenz.tsx.
 * K2 thresholds: ≥90 ok (grün), 70–89 info (blau), <70 decide (orange).
 * Uses OUR Badge component + our sem-* tokens.
 */
import { cn } from '../../../lib/cn';
import { Badge } from '../../../components/ui/Badge';
import type { BadgeTone } from '../types';

export function konfidenzTone(value: number): BadgeTone {
  if (value >= 90) return 'ok';
  if (value >= 70) return 'info';
  return 'decide';
}

function konfidenzBarClass(value: number): string {
  if (value >= 90) return 'bg-sem-ok';
  if (value >= 70) return 'bg-sem-info';
  return 'bg-sem-decide';
}

function konfidenzTextClass(value: number): string {
  if (value >= 90) return 'text-sem-ok';
  if (value >= 70) return 'text-sem-info';
  return 'text-sem-decide';
}

export function KonfidenzBadge({ value, className }: { value: number; className?: string }) {
  return (
    <Badge variant={konfidenzTone(value)} className={cn('shrink-0', className)}>
      KI {value}%
    </Badge>
  );
}

export function KonfidenzBar({ value, className }: { value: number; className?: string }) {
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <div className="flex items-center justify-between text-xs">
        <span className="text-muted-foreground">KI-Konfidenz</span>
        <span className={cn('font-medium tabular-nums', konfidenzTextClass(value))}>{value}%</span>
      </div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-muted">
        <div
          className={cn('h-full rounded-full transition-all', konfidenzBarClass(value))}
          style={{ width: `${value}%` }}
        />
      </div>
    </div>
  );
}
